import axios from "axios";
import { ajaxUri } from "../../../consts/index";
import store from "../store";
import GKEvent from "../../../events";
import state from "../../../state";
import { inArray, inlinePayload } from "../../../../lib/functions";

export const fetchPages = (loadIncrement = null, cb = () => {}) => {
  return (dispatch) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "getPages",
      },
    })
      .then((result) => {
        if (loadIncrement)
          dispatch({ type: "LOAD_INCREMENT", toAdd: parseInt(loadIncrement) });

        dispatch({ type: "LIST_PAGES", pages: result.data });
        cb();
      })
      .catch((error) => {
        dispatch({ type: "LIST_PAGES", pages: [] });
      });
  };
};

export const createPage = (pageDatas = null, pageId = null, cb = () => {}) => {
  return (dispatch) => {
    if (pageDatas) {
      axios({
        method: "post",
        url: ajaxUri,
        data: {
          request: pageId ? "updatePageSettings" : "createCMSPage",
          pageid: pageId,
          settings: pageDatas,
        },
      })
        .then((result) => {
          if (result.data.status === "success") dispatch(fetchPages(null, cb));
          else GKEvent.notification(result.data.status, result.data.message);
        })
        .catch((error) => {});
    }
  };
};

export const deletePage = (toRemove = null, cb = () => {}) => {
  return (dispatch) => {
    if (toRemove) {
      axios({
        method: "post",
        url: ajaxUri,
        data: {
          request: "deleteCMSPage",
          id_cms: toRemove,
        },
      })
        .then((result) => {
          if (result.data.status === "success") dispatch(fetchPages(null, cb));
        })
        .catch((error) => {});
    }
  };
};

const _saveLayout = (screenShot = "", name = "", type = "", pageId = "") => {
  const payload = state.getStorableState();

  const requiredElementsGroup = {
    category: ["category_title", "category_products"],
    checkout: ["checkout_steps", "checkout_summary", "checkout_form"],
    shoppingcart: ["summary"],
    product: [
      "product_pictures",
      "product_title",
      "product_attributes",
      "product_pricing",
    ],
    upsell: [
      "upsell_product_title",
      "upsell_product_pictures",
      "upsell_product_pricing",
      "upsell_product_attributes",
      "upsell_add_to_cart",
      "upsell_nothankyou",
    ],
  };

  let index;
  let missingElements = "0";

  // if (this.props.currentPage.includes("product_")) index = "product";
  // else if (this.props.currentPage.includes("upsell_")) index = "upsell";
  // else
  index = "product";

  if (requiredElementsGroup[index] !== undefined) {
    const elements = inlinePayload(state.getStorableState());

    requiredElementsGroup[index].forEach((element) => {
      if (!inArray(element, elements)) {
        missingElements = "1";
        return;
      }
    });
  }


  axios({
    method: "post",
    url: ajaxUri,
    data: {
      request: "insert",
      target: "payload",
      pageid: pageId,
      payload: payload,
      missing_element: missingElements,
      screen_shot: screenShot,
      name: name,
      type: type,
    },
  })
    .then((result) => {

      fetchPages(null, () => {});
      return result;
    })
    .catch((error) => {
      return [];
    });
};

export const createLayout = (target = null, cb = () => {}, copy = false) => {
  return (dispatch) => {
    if (target) {
      axios({
        method: "post",
        url: ajaxUri,
        data: {
          request: "createNewPayload",
          target: target,
        },
      })
        .then((result) => {

          if (copy) _saveLayout("", "", "", result.data.pageId);

          if (result.data.status === "success") {
            dispatch(fetchPages(null, cb));
          }
        })
        .catch((error) => {});
    }
  };
};

export const deleteLayout = (layoutId = null, cb = () => {}) => {
  return (dispatch) => {
    if (layoutId) {
      axios({
        method: "post",
        url: ajaxUri,
        data: {
          request: "deletePayload",
          pageid: layoutId,
        },
      })
        .then((result) => {
          if (result.data.status === "success") dispatch(fetchPages(null, cb));
        })
        .catch((error) => {});
    }
  };
};

export const renameLayout = (pageId = null, name = null, cb = () => {}) => {
  return (dispatch) => {
    if (pageId && name) {
      axios({
        method: "post",
        url: ajaxUri,
        data: {
          request: "renamePayload",
          pageid: pageId,
          name: name,
        },
      })
        .then((result) => {
          if (result.data.status === "success") dispatch(fetchPages(null, cb));
        })
        .catch((error) => {});
    }
  };
};

export const changePage = (currentPage = null, type = "forward") => {
  return (dispatch) => {
    if (type === "forward") {
      dispatch({ type: "ADD_PAGE_TO_STACK", page: currentPage });
    }
    if (type === "back") {
      const pageStack = store.getState().rootReducer.pageStack;
      if (pageStack.length > 1) {
        pageStack.pop();
        dispatch({ type: "POP_FROM_PAGE_STACK", pageStack: pageStack });
      }
      currentPage = pageStack[pageStack.length - 1];
    }
    if (currentPage) {
      if (
        store.getState().rootReducer.savedPage ||
        store.getState().rootReducer.saveAlert
      ) {
        dispatch({ type: "SET_CURRENTPAGE", value: currentPage });
        dispatch({ type: "SET_SAVEALERT", value: null });
      } else dispatch({ type: "SET_SAVEALERT", value: currentPage });
    }
  };
};

export const savePage = (status = true) => {
  return (dispatch) => {
    dispatch({ type: "SET_SAVEDPAGE", savedPage: status });
  };
};
export const showEye = (pageUrl = "") => {
  return (dispatch) => {
    dispatch({ type: "SET_SHOW_EYE", url: pageUrl });
  };
};
